import { Component, OnInit, Inject, AfterViewInit, ElementRef, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs: any;
import { SessionService } from '../../shared/services/session.service';
import { LyssnapaalfabetetcapsService } from './lyssna-pa-alfabetet-caps.service';
import { Alphabet } from './lyssna-pa-alfabetet-caps.models';



@Component({
  selector: 'app-lyssna-pa-alfabetet-caps',
  templateUrl: './lyssna-pa-alfabetet-caps.component.html',
  styleUrls: ['./lyssna-pa-alfabetet-caps.component.scss']
})

export class LyssnapaalfabetetcapsComponent implements OnInit {
  private stage: any;
  public bloburl: string;
  alphapet: Alphabet;

  errorMessage: string;

  constructor(private sessionService: SessionService, private alphabetService: LyssnapaalfabetetcapsService, public thisDialogRef: MatDialogRef<LyssnapaalfabetetcapsComponent>, @Inject(MAT_DIALOG_DATA) public data: string) { this.bloburl = this.sessionService.bloburl; }


  ngOnInit() {
    this.shelf();

  }

  shelf() {

    //audio load concept for ipad/mac
    var sounds: any[string];
    sounds = document.getElementById("source");
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    var audio_loaded = 0;
   /*update jan 20*/
    if (is_safari) {
      var src_text = sounds.src;
      sounds.src = src_text.replace(".mp3", ".aiff");
      sounds.type = "";
      sounds.load();
      sounds.play();
      sounds.muted = true;
    }
  /*update jan 20*/

    //audio load concept for ipad/mac

    var stage = new createjs.Stage("fk_canvas");
    this.stage = stage;
    createjs.Touch.enable(stage);

    var fk_canvas: any = document.getElementById('fk_canvas');
    fk_canvas.width = 1785;
    fk_canvas.height = 885;

    var frame_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/shelf_img.png");
    frame_img.setTransform(395, 0, 0.83, 0.83);

    let playsound: any = new createjs.Container();

    var Play_button1 = new Image();
    Play_button1.crossOrigin = "Anonymous";
    Play_button1.src = "/Lasresan/FK/FK-Alphabetshelf/Version1/Images/play.png";

    var Play_button = new createjs.Bitmap(Play_button1);
    Play_button.setTransform(10, 10, 1, 1);

    playsound.addChild(Play_button);
    playsound.setTransform(160, 700);
    playsound.cursor = "pointer";
    // playsound.alpha = 0.5; for safari(ipad and mac)
    playsound.alpha = 0.5;

    let status: any;

    //30 containers for shelfs
    let alphabet_A: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);

    var capA = new Image();
    capA.crossOrigin = "Anonymous";
    capA.src = "/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_A.png";

    var cap_A = new createjs.Bitmap(capA);
    cap_A.setTransform(17, 85, 0.52, 0.52);

    alphabet_A.name = "alphabet";
    alphabet_A.id = 1;

    var lightimg = new Image();
    lightimg.crossOrigin = "Anonymous";
    lightimg.src = "/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png";

    var light_img = new createjs.Bitmap(lightimg);
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = true;

    alphabet_A.addChild(img_rect, cap_A, light_img);
    alphabet_A.setTransform(436, 54);


    let alphabet_B: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_B = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_B.png");
    cap_B.setTransform(17, 85, 0.52, 0.52);

    alphabet_B.name = "alphabet";
    alphabet_B.id = 2;
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_B.addChild(img_rect, cap_B, light_img);
    alphabet_B.setTransform(588, 54);


    let alphabet_C: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_C = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_C.png");
    cap_C.setTransform(20, 85, 0.52, 0.52);


    alphabet_C.name = "alphabet";
    alphabet_C.id = 3;
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_C.addChild(img_rect, cap_C, light_img);
    alphabet_C.setTransform(738, 54);


    let alphabet_D: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_D = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_D.png");
    cap_D.setTransform(20, 85, 0.52, 0.52);


    alphabet_D.name = "alphabet";
    alphabet_D.id = 4;
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_D.addChild(img_rect, cap_D, light_img);
    alphabet_D.setTransform(890, 54);

    let alphabet_E: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_E = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_E.png");
    cap_E.setTransform(17, 85, 0.52, 0.52);


    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;

    alphabet_E.addChild(img_rect, cap_E, light_img);
    alphabet_E.setTransform(1042, 54);
    alphabet_E.name = "alphabet";
    alphabet_E.id = 5;



    let alphabet_F: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_F = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_F.png");
    cap_F.setTransform(16, 85, 0.52, 0.52);


    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;

    alphabet_F.addChild(img_rect, cap_F, light_img);
    alphabet_F.setTransform(1192, 54);
    alphabet_F.name = "alphabet";
    alphabet_F.id = 6;

    let alphabet_G: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_G = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_G.png");
    cap_G.setTransform(21, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_G.addChild(img_rect, cap_G, light_img);
    alphabet_G.setTransform(436, 204);
    alphabet_G.name = "alphabet";
    alphabet_G.id = 7;

    let alphabet_H: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_H = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_H.png");
    cap_H.setTransform(19, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_H.addChild(img_rect, cap_H, light_img);
    alphabet_H.setTransform(588, 204);
    alphabet_H.name = "alphabet";
    alphabet_H.id = 8;

    let alphabet_I: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_I = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_I.png");
    cap_I.setTransform(19, 85, 0.52, 0.52);

    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;


    alphabet_I.addChild(img_rect, cap_I, light_img);
    alphabet_I.setTransform(738, 204);
    alphabet_I.name = "alphabet";
    alphabet_I.id = 9;

    let alphabet_J: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_J = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_J.png");
    cap_J.setTransform(16, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_J.addChild(img_rect, cap_J, light_img);
    alphabet_J.setTransform(890, 204);
    alphabet_J.name = "alphabet";
    alphabet_J.id = 10;

    let alphabet_K: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_K = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_K.png");
    cap_K.setTransform(16, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_K.addChild(img_rect, cap_K, light_img);
    alphabet_K.setTransform(1042, 204);
    alphabet_K.name = "alphabet";
    alphabet_K.id = 11;

    let alphabet_L: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_L = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_L.png");
    cap_L.setTransform(17, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    light_img.alpha = 0;
    alphabet_L.addChild(img_rect, cap_L, light_img);
    alphabet_L.setTransform(1192, 204);
    alphabet_L.name = "alphabet";
    alphabet_L.id = 12;


    let alphabet_M: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_M = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_M.png");
    cap_M.setTransform(18, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_M.addChild(img_rect, cap_M, light_img);
    alphabet_M.setTransform(436, 354);
    alphabet_M.name = "alphabet";
    light_img.alpha = 0;
    alphabet_M.id = 13;


    let alphabet_N: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_N = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_N.png");
    cap_N.setTransform(19, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_N.addChild(img_rect, cap_N, light_img);
    alphabet_N.setTransform(588, 354);
    alphabet_N.name = "alphabet";
    light_img.alpha = 0;
    alphabet_N.id = 14;


    let alphabet_O: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_O = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_O.png");
    cap_O.setTransform(20, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_O.addChild(img_rect, cap_O, light_img);
    alphabet_O.setTransform(738, 354);
    alphabet_O.name = "alphabet";
    light_img.alpha = 0;
    alphabet_O.id = 15;


    let alphabet_P: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_P = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_P.png");
    cap_P.setTransform(20, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_P.addChild(img_rect, cap_P, light_img);
    alphabet_P.setTransform(890, 354);
    alphabet_P.name = "alphabet";
    light_img.alpha = 0;
    alphabet_P.id = 16;


    let alphabet_Q: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_Q = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_Q.png");
    cap_Q.setTransform(19, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_Q.addChild(img_rect, cap_Q, light_img);
    alphabet_Q.setTransform(1042, 354);
    alphabet_Q.name = "alphabet";
    light_img.alpha = 0;
    alphabet_Q.id = 17;

    let alphabet_R: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_R = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_R.png");
    cap_R.setTransform(20, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_R.addChild(img_rect, cap_R, light_img);
    alphabet_R.setTransform(1192, 354);
    alphabet_R.name = "alphabet";
    light_img.alpha = 0;
    alphabet_R.id = 18;

    let alphabet_S: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_S = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_S.png");
    cap_S.setTransform(22, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_S.addChild(img_rect, cap_S, light_img);
    alphabet_S.setTransform(436, 504);
    alphabet_S.name = "alphabet";
    light_img.alpha = 0;
    alphabet_S.id = 19;


    let alphabet_T: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_T = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_T.png");
    cap_T.setTransform(19, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_T.addChild(img_rect, cap_T, light_img);
    alphabet_T.setTransform(588, 504);
    alphabet_T.name = "alphabet";
    light_img.alpha = 0;
    alphabet_T.id = 20;

    let alphabet_U: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_U = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_U.png");
    cap_U.setTransform(22, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_U.addChild(img_rect, cap_U, light_img);
    alphabet_U.setTransform(738, 504);
    alphabet_U.name = "alphabet";
    light_img.alpha = 0;
    alphabet_U.id = 21;

    let alphabet_V: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_V = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_V.png");
    cap_V.setTransform(17, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_V.addChild(img_rect, cap_V, light_img);
    alphabet_V.setTransform(890, 504);
    alphabet_V.name = "alphabet";
    light_img.alpha = 0;
    alphabet_V.id = 22;

    let alphabet_W: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_W = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_W.png");
    cap_W.setTransform(20.5, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_W.addChild(img_rect, cap_W, light_img);
    alphabet_W.setTransform(1042, 504);
    alphabet_W.name = "alphabet";
    light_img.alpha = 0;
    alphabet_W.id = 23;

    let alphabet_X: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_X = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_X.png");
    cap_X.setTransform(19, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_X.addChild(img_rect, cap_X, light_img);
    alphabet_X.setTransform(1192, 504);
    alphabet_X.name = "alphabet";
    light_img.alpha = 0;
    alphabet_X.id = 24;

    let alphabet_Y: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_Y = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_Y.png");
    cap_Y.setTransform(19, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_Y.addChild(img_rect, cap_Y, light_img);
    alphabet_Y.setTransform(436, 654);
    alphabet_Y.name = "alphabet";
    light_img.alpha = 0;
    alphabet_Y.id = 25;


    let alphabet_Z: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_Z = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_Z.png");
    cap_Z.setTransform(17, 85, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_Z.addChild(img_rect, cap_Z, light_img);
    alphabet_Z.setTransform(588, 654);
    alphabet_Z.name = "alphabet";
    light_img.alpha = 0;
    alphabet_Z.id = 26;


    let alphabet_Å: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_Å = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_Å.png");
    cap_Å.setTransform(17, 68, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_Å.addChild(img_rect, cap_Å, light_img);
    alphabet_Å.setTransform(738, 654);
    alphabet_Å.name = "alphabet";
    light_img.alpha = 0;
    alphabet_Å.id = 27;

    let alphabet_Ä: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_Ä = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_Ä.png");
    cap_Ä.setTransform(19, 72, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_Ä.addChild(img_rect, cap_Ä, light_img);
    alphabet_Ä.setTransform(890, 654);
    alphabet_Ä.name = "alphabet";
    light_img.alpha = 0;
    alphabet_Ä.id = 28;

    let alphabet_Ö: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    var cap_Ö = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/Shelf_Caps_Ö.png");
    cap_Ö.setTransform(18, 73, 0.52, 0.52);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;
    alphabet_Ö.addChild(img_rect, cap_Ö, light_img);
    alphabet_Ö.setTransform(1042, 654);
    alphabet_Ö.name = "alphabet";
    light_img.alpha = 0;
    alphabet_Ö.id = 29;


    let alphabet_emp: any = new createjs.Container();
    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(1).f("#FCF7CD").drawRect(0, 0, 135.5, 135.5);
    img_rect.setTransform(10, 62);
    alphabet_emp.setTransform(1192, 654);
    alphabet_emp.name = "alphabet";
    alphabet_emp.id = 30;
    var img_30 = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/drake_10.png");
    img_30.setTransform(45, 94);
    var light_img = new createjs.Bitmap("/Lasresan/FK/FK-Alphabetshelf/Version1/Images/blub_img.png");
    light_img.setTransform(0, 52, 0.258, 0.258);
    light_img.visible = false;

    alphabet_emp.addChild(img_rect, img_30, light_img);

    stage.addChild(frame_img, alphabet_A, alphabet_B, alphabet_C, alphabet_D, alphabet_E, alphabet_F, alphabet_G, alphabet_H, alphabet_I,
      alphabet_J, alphabet_K, alphabet_L, alphabet_M, alphabet_N, alphabet_O, alphabet_P, alphabet_Q, alphabet_R, alphabet_S, alphabet_T,
      alphabet_U, alphabet_V, alphabet_W, alphabet_X, alphabet_Y, alphabet_Z, alphabet_Å, alphabet_Ä, alphabet_Ö, alphabet_emp, playsound);

    //audio load concept for ipad/mac
    if (is_safari) {
      var player01 = document.getElementById("source");
      player01.ontimeupdate = function () {
        if (parseInt(sounds.currentTime) > 0) {
          audio_loaded = 1;
          playsound.alpha = 1;
        }
      };
    }
    else {
      audio_loaded = 1;
      playsound.alpha = 1;
    }

    //audio load concept for ipad/mac

    var stopfunction = playsound.addEventListener("click", startFunction);

    function startFunction() {

      //audio load concept for ipad/mac
      if (audio_loaded == 1) {
        showbulb();
        tweenbulb();
        stopClick();
        startClick();
      }
      //audio load concept for ipad/mac
    }


    function stopClick() {
      if (stopfunction == false) {
        playsound.removeEventListener("click", startFunction);
        playsound.cursor = "default";
      } else (stopfunction == true)
      {
        playsound.removeEventListener("click", startFunction);
        playsound.cursor = "default";
      }
    }
    function startClick() {
      setTimeout(function () { playsound.addEventListener("click", startFunction); playsound.cursor = "pointer"; }, 54000);

    }

    function hidetweenbulb() {
      alphabet_A.children[2].visible = true;
      alphabet_B.children[2].visible = false;
      alphabet_C.children[2].visible = false;
      alphabet_D.children[2].visible = false;
      alphabet_E.children[2].visible = false;
      alphabet_F.children[2].visible = false;

      alphabet_G.children[2].visible = false;
      alphabet_H.children[2].visible = false;
      alphabet_I.children[2].visible = false;
      alphabet_J.children[2].visible = false;
      alphabet_K.children[2].visible = false;
      alphabet_L.children[2].visible = false;

      alphabet_M.children[2].visible = false;
      alphabet_N.children[2].visible = false;
      alphabet_O.children[2].visible = false;
      alphabet_P.children[2].visible = false;
      alphabet_Q.children[2].visible = false;
      alphabet_R.children[2].visible = false;

      alphabet_S.children[2].visible = false;
      alphabet_T.children[2].visible = false;
      alphabet_U.children[2].visible = false;
      alphabet_V.children[2].visible = false;
      alphabet_W.children[2].visible = false;
      alphabet_X.children[2].visible = false;

      alphabet_Y.children[2].visible = false;
      alphabet_Z.children[2].visible = false;
      alphabet_Å.children[2].visible = false;
      alphabet_Ä.children[2].visible = false;
      alphabet_Ö.children[2].visible = false;

    }

    function showbulb() {
      hidetweenbulb();

      alphabet_A.children[2].visible = true;
      if (is_safari) {
        sounds.pause();
        sounds.muted = false;
        sounds.currentTime = 0;
      }
      sounds.play();
    }

    function tweenbulb() {

      alphabet_A.children[2].visible = true;
      createjs.Tween.get(alphabet_A.children[2])
        .wait(1400).to({ alpha: 0 }, 0)
        .wait(54000).to({ alpha: 1 }, 0);

      alphabet_B.children[2].visible = true;
      createjs.Tween.get(alphabet_B.children[2])
        .wait(1900).to({ alpha: 1 }, 0)
        .wait(1200).to({ alpha: 0 }, 0);

      alphabet_C.children[2].visible = true;
      createjs.Tween.get(alphabet_C.children[2])
        .wait(3100).to({ alpha: 1 }, 0)
        .wait(1700).to({ alpha: 0 }, 0);

      alphabet_D.children[2].visible = true;
      createjs.Tween.get(alphabet_D.children[2])
        .wait(5400).to({ alpha: 1 }, 0)
        .wait(1200).to({ alpha: 0 }, 0);

      alphabet_E.children[2].visible = true;
      createjs.Tween.get(alphabet_E.children[2])
        .wait(7200).to({ alpha: 1 }, 0)
        .wait(1200).to({ alpha: 0 }, 0);

      alphabet_F.children[2].visible = true;
      createjs.Tween.get(alphabet_F.children[2])
        .wait(9400).to({ alpha: 1 }, 0)
        .wait(1200).to({ alpha: 0 }, 0);

      alphabet_G.children[2].visible = true;
      createjs.Tween.get(alphabet_G.children[2])
        .wait(11000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_H.children[2].visible = true;
      createjs.Tween.get(alphabet_H.children[2])
        .wait(13000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_I.children[2].visible = true;
      createjs.Tween.get(alphabet_I.children[2])
        .wait(15000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_J.children[2].visible = true;
      createjs.Tween.get(alphabet_J.children[2])
        .wait(17000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_K.children[2].visible = true;
      createjs.Tween.get(alphabet_K.children[2])
        .wait(19000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_L.children[2].visible = true;
      createjs.Tween.get(alphabet_L.children[2])
        .wait(21000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_M.children[2].visible = true;
      createjs.Tween.get(alphabet_M.children[2])
        .wait(22800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_N.children[2].visible = true;
      createjs.Tween.get(alphabet_N.children[2])
        .wait(24800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_O.children[2].visible = true;
      createjs.Tween.get(alphabet_O.children[2])
        .wait(26800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_P.children[2].visible = true;
      createjs.Tween.get(alphabet_P.children[2])
        .wait(28800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_Q.children[2].visible = true;
      createjs.Tween.get(alphabet_Q.children[2])
        .wait(30600).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_R.children[2].visible = true;
      createjs.Tween.get(alphabet_R.children[2])
        .wait(32400).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_S.children[2].visible = true;
      createjs.Tween.get(alphabet_S.children[2])
        .wait(34300).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_T.children[2].visible = true;
      createjs.Tween.get(alphabet_T.children[2])
        .wait(36000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_U.children[2].visible = true;
      createjs.Tween.get(alphabet_U.children[2])
        .wait(38000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_V.children[2].visible = true;
      createjs.Tween.get(alphabet_V.children[2])
        .wait(40000).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_W.children[2].visible = true;
      createjs.Tween.get(alphabet_W.children[2])
        .wait(41800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_X.children[2].visible = true;
      createjs.Tween.get(alphabet_X.children[2])
        .wait(43800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_Y.children[2].visible = true;
      createjs.Tween.get(alphabet_Y.children[2])
        .wait(45500).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_Z.children[2].visible = true;
      createjs.Tween.get(alphabet_Z.children[2])
        .wait(47500).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_Å.children[2].visible = true;
      createjs.Tween.get(alphabet_Å.children[2])
        .wait(49300).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_Ä.children[2].visible = true;
      createjs.Tween.get(alphabet_Ä.children[2])
        .wait(51100).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

      alphabet_Ö.children[2].visible = true;
      createjs.Tween.get(alphabet_Ö.children[2])
        .wait(52800).to({ alpha: 1 }, 0)
        .wait(1500).to({ alpha: 0 }, 0);

    }


    stage.mouseMoveOutside = false;
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;

  }



  onCloseCancel() {

    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
    let toggler: any = document.getElementById("toggler");
    if (toggler) {
      toggler.style.visibility = "visible";
    }
  }
}
